import React, {useEffect, useState} from 'react'
import {GoogleMap, Marker} from '@react-google-maps/api'
import {getGeoCoordinates} from '../_requests'
import {useParams} from 'react-router-dom'

const containerStyle = {
  width: '100%',
  height: '500px',
}

const center = {
  lat: 25.276987,
  lng: 55.296249,
}

const GeoMap: React.FC = () => {
  const {id, date} = useParams()

  const [coordinates, setCoordinates] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      const res = await getGeoCoordinates(id, date)
      setCoordinates(res)
    }

    fetchData()
  }, [id, date])

  return (
    <div className='my-4'>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
        {/* You can add markers, polylines, etc. here if needed */}
        {coordinates.map((item, index) => (
          <Marker position={item} key={index} label={`C${index + 1}`} />
        ))}
      </GoogleMap>
    </div>
  )
}

export default GeoMap
